// extracted by mini-css-extract-plugin
export default {"NoButton":"DetailModal_NoButton__bmmtv","MarginTop":"DetailModal_MarginTop__KTy-g","TextEnd":"DetailModal_TextEnd__p5ueh","Modal":"DetailModal_Modal__TgwX8"};